import { create } from 'zustand';

interface EncounterStore {
    encounterId: string | null;
    setEncounterId: (id: string) => void;
    clearEncounterId: () => void;
}

const useEncounterStore = create<EncounterStore>((set) => ({
    encounterId: null,
    setEncounterId: (id: string) => set({ encounterId: id }),
    clearEncounterId: () => set({ encounterId: null }),
}));

export default useEncounterStore;